
import React from 'react';
import { Star } from 'lucide-react';

const CustomerTestimonials = () => {
  const testimonials = [
    {
      text: "Prix très compétitifs et service rapide. L'équipe est professionnelle et connaît parfaitement son métier. Je recommande !",
      author: "Jean-Marc D.",
      location: "Électricien - Rodez"
    },
    {
      text: "Excellent service de collecte pour notre entreprise. Intervention rapide et prix transparents. Partenaire de confiance.",
      author: "Sophie L.",
      location: "Directrice - Toulouse"
    },
    {
      text: "Groupe Fabre nous accompagne depuis des années. Service fiable, prix justes et équipe toujours disponible.",
      author: "Pierre M.",
      location: "Plombier - Albi"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-fabre-gray mb-4">
            Ils nous font confiance
          </h2>
          <p className="text-gray-600">
            Découvrez les retours de nos clients satisfaits
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-600 mb-4 italic">
                "{testimonial.text}"
              </p>
              <div className="text-sm">
                <div className="font-bold">{testimonial.author}</div>
                <div className="text-gray-500">{testimonial.location}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerTestimonials;
